Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    legendItemSpacingVertical: 8,
    legendItemSpacingHorizontal: 24,
    legendItemBorderRadius: 4,
    legendValueSpacingHorizontal: 12,
    legendValueFontWeight: 600,
    legendSwatchSpacingHorizontal: 8,
    legendSwatchOpacityDefault: 100,
    legendSwatchOpacityInactive: 20,
    legendSwatchMotionDuration: "150ms",
    legendSwatchMotionFunction: "ease",
    legendTooltipCrosshairWidth: 1,
    legendTooltipCrosshairColor: tokens.themeBorderDefault,
    legendTooltipArrowHeight: 8
  }
};